
import React from 'react';
// --- external imports ------

import { default as DefaultNewspaperPreview } from './NewspaperPreview';
// --- local imports ------

function NewspaperPreviewWrapper(props) {
	const NewspaperPreview = props.displayDetails?.previewRenderer 
		? props.displayDetails?.previewRenderer?.(props.entry) 
		: DefaultNewspaperPreview;

	return (
		<NewspaperPreview  {...props} />
	);
}

export default NewspaperPreviewWrapper;
